// extracted by mini-css-extract-plugin
export default {"header":"Header_header__BvvwQ","main-image":"Header_main-image__kQmew"};